module.exports = __webpack_public_path__ + "img/1_027.6f5c5f0f.jpg";